import { Link, useNavigate } from "react-router-dom"
import { IoMdExit } from "react-icons/io"
import { FaHome, FaBars, FaTimes } from "react-icons/fa"
import { LiaFileSignatureSolid } from "react-icons/lia"
import { RiMessageLine, RiStopCircleLine, RiUserStarFill } from "react-icons/ri"
import { MdOutlineFactory } from "react-icons/md"
import logo from "../../assets/logo.png"
import { styles } from "../styles"
import "./styles.css"

export const Navbar: React.FC<{ isOpen: boolean, setIsOpen: React.Dispatch<React.SetStateAction<boolean>> }> = (
  { isOpen, setIsOpen }
) => {
  const navigate = useNavigate()
  const { nome } = JSON.parse(localStorage.getItem("currentUser") as string)

  const handleLogout = () => {
    localStorage.removeItem("currentUser")
    navigate("/")
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  return (
    <>
      <div className="d-md-none mobile-menu-button" style={{ width: "100%" }}>
        <button
          className="btn btn-dark d-flex align-items-center justify-content-between w-100"
          style={{
            padding: "10px",
            backgroundColor: "#1D1701",
            border: "none",
            borderRadius: "0",
          }}
        >
          <img src={logo} alt="logo" style={{ width: "50px" }} />

          {isOpen ? (
            <FaTimes size={25} onClick={toggleMenu} />
          ) : (
            <FaBars size={25} onClick={toggleMenu} />
          )}
        </button>
      </div>


      <nav
        className={`col-md-2 d-md-block sidebar ${isOpen ? "mobile-open" : ""}`}
        style={{
          position: "fixed",
          height: "100vh",
          zIndex: 1000,
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s ease-in-out",
          backgroundColor: "#1D1701",
          overflowY: "auto"
        }}
      >
        <div className="d-flex flex-column align-items-center pt-3">
          <img src={logo} alt="logo" style={{ width: "130px" }} />
          <span className="text-white mt-1" style={{ fontSize: "12px" }}>
            Usuário logado:
          </span>
          <span className="text-white" style={{ fontSize: "12px" }}>{nome}</span>
          <hr style={{ width: "100%", backgroundColor: "#4a4533", height: "1px", margin: "5px 0px" }} />
        </div>

        <div className="sidebar-sticky" id="navbarNavAltMarkup">
          <div className="nav flex-column text-white">
            <Link
              id="nav-link-dashboard"
              className="nav-link"
              to="/dashboard"
              onClick={closeMenu}
              style={{
                backgroundColor: window.location.pathname === "/dashboard" ? "#4a4533" : "",
                display: "flex",
                alignItems: "center",
                padding: "12px 15px"
              }}
            >
              <FaHome size={25} color={"white"} />
              <span className='ml-3 text-white'>
                Início
              </span>
            </Link>

            <Link
              id="nav-link-signature"
              className="nav-link"
              to="/assinaturas"
              onClick={closeMenu}
              style={{
                backgroundColor: window.location.pathname === "/assinaturas" ? "#4a4533" : "",
                display: "flex",
                alignItems: "center",
                padding: "12px 15px"
              }}
            >
              <LiaFileSignatureSolid size={25} color={"white"} />
              <span
                className='ml-3 text-white'
                style={{ color: window.location.pathname === "/assinaturas" ? styles.color.primary : "white" }}
              >
                Assinaturas
              </span>
            </Link>

            <Link
              id="nav-link-super-user"
              className="nav-link"
              to="/super-usuario"
              onClick={closeMenu}
              style={{
                backgroundColor: window.location.pathname === "/super-usuario" ? "#4a4533" : "",
                display: "flex",
                alignItems: "center",
                padding: "12px 15px"
              }}
            >
              <RiUserStarFill size={25} color={"white"} />
              <span
                className='ml-3 text-white'
              >
                Super Usuário
              </span>
            </Link>
            <Link
              id="nav-link-super-user"
              className="nav-link"
              to="/contingencia"
              onClick={closeMenu}
              style={{
                backgroundColor: window.location.pathname === "/contingencia" ? "#4a4533" : "",
                display: "flex",
                alignItems: "center",
                padding: "12px 15px"
              }}
            >
              <RiStopCircleLine size={25} color={"white"} />
              <span
                className='ml-3 text-white'
              >
                Contingência
              </span>
            </Link>
            <Link
              id="nav-link-super-user"
              className="nav-link"
              to="/gerenciar-avisos"
              onClick={closeMenu}
              style={{
                backgroundColor: window.location.pathname === "/gerenciar-avisos" ? "#4a4533" : "",
                display: "flex",
                alignItems: "center",
                padding: "12px 15px"
              }}
            >
              <RiMessageLine size={25} color={"white"} />
              <span
                className='ml-3 text-white'
              >
                Avisos
              </span>
            </Link>
            <Link
              id="nav-link-register-company"
              className="nav-link"
              to="/empresas"
              onClick={closeMenu}
              style={{
                backgroundColor: window.location.pathname === "/empresas" ? "#4a4533" : "",
                display: "flex",
                alignItems: "center",
                padding: "12px 15px"
              }}
            >
              <MdOutlineFactory size={25} color={"white"} />
              <span
                className='ml-3 text-white'
              >
                Empresas
              </span>
            </Link>

          </div>

          <div
            onClick={() => {
              handleLogout()
              closeMenu()
            }}
            className="nav-link"
            style={{
              position: "absolute",
              bottom: 20,
              left: 15,
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }}
          >
            <IoMdExit size="25" style={{ color: "white" }} />
            <span className="ml-3 text-white">Sair</span>
          </div>
        </div>
      </nav>
    </>
  )
}